// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sza-sa-var-chart[data-v-0efe15ca] {\n  background-color: #fff;\n}\n.sza-sa-var-chart .control[data-v-0efe15ca] {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
